import { ChangeEvent } from "react";
import { useFormContext } from "../../../../common/contexts/FormContext";
import { Errors, Field } from "../../../../Interface/scheduler/form";
import { getValidationError } from "../../../../common/components/FieldValidator/validateFields";
import InputTextWithButton from "../../../../common/components/InputTextWithButton/InputTextWithButton";

interface BookInspectionProps {
  field: Field;
  errors: Errors;
  setErrors: React.Dispatch<React.SetStateAction<Errors>>;
}

const BookInspectionFormBuilder = ({
  field,
  errors,
  setErrors,
}: BookInspectionProps): JSX.Element => {
  const { setFormValues } = useFormContext();
  const handleChange = async (
    e: ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const { name, value } = e.target;
    if (!name) return;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value as string,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: getValidationError(field, value as string) || "",
    }));
  };

  const renderFormField = (field: Field) => {
    const error = errors[field.id];
    switch (field.type) {
      case "zipcode":
        return (
          <>
            <InputTextWithButton
              field={field}
              error={error}
              handleChange={handleChange}
            />
          </>
        );
    }
  };

  return <>{renderFormField(field)}</>;
};

export default BookInspectionFormBuilder;
